<ion-header>
  <ion-toolbar>
    <ion-title>TREC+ Informazioni sull'Assistente Vocale</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h2>Cos'è l'Assistente Vocale</h2>
  <p>
    L'Assistente Vocale del cruscotto medico <strong>TREC+</strong> consente di interagire con il sistema
    tramite comandi vocali. Clicca sull'icona in basso a destra, pronuncia la tua richiesta e riceverai
    una risposta automatica.
  </p>

  <h3>Cosa può fare</h3>
  <div class="feature-list">
    <div>▶️ Navigare tra le principali funzionalità della home page</div>
    <div>▶️ Cercare informazioni cliniche dei pazienti</div>
    <div>▶️ Inviare messaggi di chat</div>
    <div>▶️ Programmare una televisita</div>
    <div>▶️ Aggiungere terapie</div>
    <div>▶️ Assegnare specifiche attività</div>
    <div>▶️ Fornirti informazioni utili</div>
  </div>

  <h3>Nota</h3>
  <p class="note">
    Questa funzionalità è in fase
    <strong>Beta</strong>
    : il comportamento può variare in base alla struttura e al contesto.
  </p>

</ion-content>